import React from 'react';
import clsx from 'clsx';
import classes from './SurveyTip.module.scss';
import PageMetaData from 'components/atoms/PageMetaData/PageMetaData';
import useTranslate from 'hooks/useTranslate';
import { SurveyTip as SurveyTipInterface } from 'constants/surveyTips';
import PageContentWrapper from 'components/templates/Page/PageContentWrapper';
import A from 'components/atoms/A/A';
import Txt from 'components/atoms/Txt/Txt';
import ShareButtons from 'components/molecules/ShareButtons/ShareButtons';
import OinqTip from 'components/assets/oinq/oinqtip.svg';

import { SURVEY_TIPS } from 'components/pages/pages';

import { graphql } from 'react-relay';
import BackButton from 'components/atoms/BackButton/BackButton';

export interface Props {
  surveyTips: SurveyTipInterface[];
  surveyTipIndex: number;
}

const SurveyTip: React.FC<Props> = ({ surveyTips, surveyTipIndex }) => {
  const translate = useTranslate();
  const { title, description, advice, header } = surveyTips[surveyTipIndex];

  return (
    <div className={classes.root}>
      <PageMetaData
        metaData={{
          title: translate(`Survey Tip %1s; - %2s;`, {
            vars: [surveyTipIndex + 1, title],
          }),
          description: translate(description.split('\n')[0]),
          imageUrl:
            'https://cdn.assets.qmee.com/colour-scheme/survey-tips/banners/SocialShareBanner.png',
          isTranslated: true,
        }}
      />

      <div className={classes.tipBanner}>
        <div className={classes.tipBannerContainer} style={{ backgroundImage: `url(${header})` }}>
          <BackButton to={SURVEY_TIPS.path} />
          <ShareButtons
            className={classes.shareButtons}
            type="noTemplate"
            shareInfo={{
              title: null,
              description: `I'm learning how to earn more whilst taking paid surveys with @qmee!`,
              url: `https://qmee.com${SURVEY_TIPS.path}`,
              imageUrl:
                'https://cdn.img.qmee.com/img/w:3840/q:75/plain/https://cdn.assets.qmee.com/images/5590-e8f3238e5fddbe11d4f9f9d075eef19c.jpg@webp',
              ref: '',
            }}
          />
        </div>
      </div>

      <PageContentWrapper topBottomPadding>
        <div className={classes.tipWrapper}>
          <nav className={classes.tipNav}>
            <ul className={classes.tipNavList}>
              {surveyTips.map((tip, tipIndex) => (
                <li key={tip.path}>
                  <A
                    to={`${SURVEY_TIPS.path}/${tip.path}`}
                    className={clsx(classes.tipNavListLink, {
                      [classes.activeLink]: tipIndex === surveyTipIndex,
                    })}
                  >
                    <Txt component="span" translateOptions={{ vars: [tipIndex + 1] }}>
                      Tip %1s;
                    </Txt>
                    <Txt>{tip.title}</Txt>
                  </A>
                </li>
              ))}
            </ul>
          </nav>

          <main className={classes.tipContent}>
            <section>
              <Txt
                component="p"
                className={classes.tipSubHeading}
                translateOptions={{ vars: [surveyTipIndex + 1] }}
              >
                Tip %1s;
              </Txt>
              <Txt component="h1" className={classes.tipTitle}>
                {title}
              </Txt>
              <Txt asMarkdown>{description}</Txt>

              <aside className={classes.tipAdvice}>
                <div className={classes.tipAdviceText}>
                  <h2 className={classes.tipAdviceTitle}>
                    <Txt>Oinq&apos;s Advice</Txt>...
                  </h2>
                  <blockquote>
                    <Txt asMarkdown>{`**&ldquo;**&nbsp;${advice.quote}&nbsp;**&rdquo;**`}</Txt>
                  </blockquote>
                  <Txt asMarkdown className={classes.tipAdviceDescription}>
                    {advice.description}
                  </Txt>
                </div>
                <OinqTip className={classes.tipAdviceImg} />
              </aside>
            </section>
          </main>
        </div>
      </PageContentWrapper>
    </div>
  );
};
export default SurveyTip;
